module.exports = __webpack_public_path__ + "img/logo.ef1bdb40.png";